import React, { useContext, useEffect } from 'react';

import ChatMessageUploadQueuePresenter from './ChatMessageUploadQueuePresenter';

import { DropzoneContext } from '../DropzoneProvider';

interface Props {
  chatRoomId: string;
}

const ChatMessageUploadQueueContainer = ({ chatRoomId }: Props) => {
  const { files, onClearUploadFiles } = useContext(DropzoneContext);

  useEffect(() => () => onClearUploadFiles(), [onClearUploadFiles]);

  return (
    <ChatMessageUploadQueuePresenter chatRoomId={chatRoomId} files={files} />
  );
};

export default ChatMessageUploadQueueContainer;
